import React from 'react';
import { useIntl } from 'react-intl';

import { IconButton } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { LumaTheme } from 'embeds/core/styles/getTheme';
import { noop } from 'lodash';

import { TextFieldSearch, Typography } from 'components/v2';

import { useTabContext } from '../context/FixedFiltersContext';

import messages from './messages';

const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportMidnight },
  },
}: LumaTheme) =>
  createStyles({
    headerWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: `${unit * 1.5}px 0 0 ${unit * 3}px`,
    },
    searchWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    selectAllCheckbox: {
      color: 'transparent !important',
    },
    icon: {
      color: colorSupportMidnight,
    },
  });

interface FilterProceduresHeaderProps extends WithStyles<typeof styles> {
  onSearchChange?: (search: string) => void;
}

const FilterProceduresHeader: React.FC<FilterProceduresHeaderProps> = ({ classes, onSearchChange = noop }) => {
  const { changeTab } = useTabContext();
  const { formatMessage } = useIntl();

  const handleOnChange = (value: string) => {
    onSearchChange(value);
  };

  return (
    <div className={classes.headerWrapper}>
      <Typography variant="supportBook">{formatMessage(messages.instructions)}</Typography>
      <div className={classes.searchWrapper}>
        <TextFieldSearch size="small" onChange={handleOnChange} />
        <IconButton onClick={() => changeTab({ tab: null, index: false })}>
          <ExpandLessIcon className={classes.icon} />
        </IconButton>
      </div>
    </div>
  );
};

export default withStyles(styles)(FilterProceduresHeader);
